<template>
  <div>
    <!-- Toggle button -->
    <div class="d-flex justify-content-end float-right">
      <b-button v-b-toggle.sidebar-right class="pasos-button mt-4 mr-4 rounded-circle theme-orange clickable">
        <font-awesome-icon :icon="['fas', 'bars']" fixed-width />
      </b-button>
    </div>

    <b-sidebar id="sidebar-right" ref="sidebar" title="Configurador" right shadow z-index="2000">
      <nav>
        <ul class="border-top" style="list-style: none; padding: 0">
          <SubmitalShowStepLink
            v-for="step in configuratorSteps"
            :step="step"
            :key="step.en"
            @step-link-clicked="goToConfiguratorStep"
          />
        </ul>
      </nav>
    </b-sidebar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SubmitalShowStepLink from '../submitals/SubmitalShowStepLink'

export default {
  name: 'NavigationSidebar',
  components: { SubmitalShowStepLink },
  computed: {
    ...mapGetters (['configuratorSteps'])
  },
  methods: {
    goToConfiguratorStep (step) {
      this.$store.commit('setCurrentStep', step.en)
      this.$refs.sidebar.hide()
    }
  }

}
</script>
